import React, { useEffect, useState } from 'react';

// reactstrap components
import { API } from 'common';
import Page from 'components/Page';
import constant from 'constant';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import { formatCurrency } from 'utils/formatCurrency';
import { formatPhone } from 'utils/formatPhone';

export default function TicketDetail() {
	const [infoTicket, setInfoTicket] = useState(null);
	const [servicesName, setServicesName] = useState(null);

	let data = useLocation();

	const { ticketId, create_date } = data.state;
	const customer = infoTicket?.customer;

	const fetch_ticket_detail = async () => {
		try {
			let response = await API.get(`report/getBillDetailV2?billId=${ticketId}`);
			if (response.status == 200) {
				let { payload } = response.data;
				setInfoTicket(payload);
				if (payload.services && payload.services.length > 0) {
					let service = payload.services.map((service) => service.serviceName);
					service = service.join(', ');
					setServicesName(service);
				}
			}
		} catch (error) {
			console.error('fetch_ticket_detail', error);
		}
	}

	useEffect(() => {
		fetch_ticket_detail();
		// keep tab 
		localStorage.setItem('active_tab', '2');
		// localStorage.setItem('active_tab_income', type);
	}, [])

	return (
		<Page title={'Ticket Details'}>
			<Container className='pt-4'>
				<Row className="ticket-detail m-0">
					<Col xs={12} className="ticket-info">
						<div className="d-flex align-items-center">
							<div className="ticket-id">
								#{infoTicket && infoTicket.billNumber}
							</div>
							<div className="ticket-time">
								{infoTicket?.payment?.strCreateDate ? moment(infoTicket?.payment?.strCreateDate, 'MM/DD/YYYY hh:mm:ss').format('MM-DD-YYYY hh:mm A') : '--'}
							</div>
						</div>
						<div className="customer-info">
							<div className="customer-name">{customer?.name || 'Unl'}</div>

							<div className="customer-phone">
								<div className="icon-phone"><PhoneIcon /></div>
								<span>{formatPhone(customer?.phone)}</span>
							</div>
						</div>
						<p className="m-0 service-title">SERVICES: {servicesName || ''}</p>
					</Col>
					<Col xs={12} className="ticket-invoice">
						<div className="d-flex mt-2 mb-2">
							<div className="title">
								Sub total
							</div>
							<div className="money">{formatCurrency(infoTicket?.subTotal)}</div>

						</div>
						<div className="d-flex mt-2 mb-2">
							<div className="title">
								Discount
							</div>
							<div className="money">{formatCurrency(infoTicket?.discount)}</div>

						</div>
						<div className="d-flex mt-2 mb-2">
							<div className="title">
								Express services
							</div>
							<div className="money">{formatCurrency(infoTicket?.expressAmount)}</div>

						</div>
						<div className="d-flex mt-2 mb-2">
							<div className="title">
								Tax
							</div>
							<div className="money">{formatCurrency(infoTicket?.tax)}</div>

						</div>
						<div className="d-flex mt-2 mb-2" style={{ borderBottom: "1px solid #b8b8b8" }}>
							<div className="title">
								Tip
							</div>
							<div className="money">{formatCurrency(infoTicket?.tip)}</div>
						</div>
						{/* <div className="d-flex mt-2 mb-2 pb-3" >
							<div className="title">
								Card Fee
							</div>
							<div className="money">{formatCurrency(infoTicket?.cashDiscountCredit)}</div>
						</div> */}
						<div className="d-flex mt-2 total font-weight-bold">
							<div style={{ flex: "1" }}>
								Total Ticket
							</div>
							<div>{formatCurrency(infoTicket?.total)}</div>
						</div>
						{/* <div className="d-flex pb-3 supply-row">
							<div className="title">
								Supply
							</div>
							<div className="money">{formatCurrency(infoTicket?.supply)}</div>
						</div> */}
					</Col>

				</Row>
				<Row className="m-0 mt-4 mb-5 ticket-customer">
					<Col xs={12} className="customer-info py-2 d-flex">
						<div className="info">
							<div className="name">REVIEW</div>
						</div>
						<div >
						</div>
					</Col>
					<Col xs={12} className="customer-feedback pt-2">
						{!infoTicket?.reviews ?
							<div className="mt-2">
								<p className="blank-reviews">Customers have not reviewed yet</p>
							</div>
							:
							<>
								<div className='feedback-text'>Feedback</div>
								<div className="smile d-flex text-center mt-2">
									{
										constant.SMILE_LIST.map((smile, index) => {
											let text_style = 'none';
											const active = infoTicket?.reviews.star === (index + 1);
											if (active) {
												text_style = '#FF7D00';
											}
											return (
												<div className="item-smile" key={index}>
													<img
														height={40}
														width={40}
														alt="..."
														src={require(`assets/img/icons/${active ? smile.file_name_active : smile.file_name}`)}
													/>
													<div className="status" style={{ color: `${text_style}` }}>{smile.label}</div>
												</div>
											)
										})
									}
								</div>
								<div className='feedback-comment mt-2'>
									<p className="title">Comment</p>
									<p className='comment'>{infoTicket?.reviews?.comment || ''}</p>
								</div>
							</>
						}
					</Col>
				</Row>
			</Container>
		</Page>
	);
}

const PhoneIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
		<path d="M13.5177 6.76643C13.6742 6.65423 13.7658 6.45768 13.7477 6.26537C13.6811 5.67121 13.5222 5.08739 13.2762 4.5423C12.7017 3.26299 11.6301 2.21498 10.337 1.67042C9.83732 1.45212 9.3034 1.32374 8.76418 1.25L8.63096 1.25C8.39718 1.27546 8.18727 1.45557 8.14004 1.68819C8.08511 1.90915 8.18462 2.15504 8.37409 2.27971C8.52747 2.38925 8.72437 2.38315 8.90243 2.41631C9.76434 2.56777 10.5817 2.97254 11.218 3.5736C11.986 4.28607 12.4889 5.27651 12.6122 6.31656C12.6295 6.50967 12.7266 6.70171 12.9004 6.79773C13.088 6.91099 13.3431 6.89906 13.5177 6.76643Z" fill="#686868" />
		<path d="M12.8886 12.9634C13.0439 12.7108 13.1224 12.4153 13.1244 12.1195C13.1252 11.5851 13.1252 11.0505 13.1244 10.5158C13.1229 10.2559 13.0693 9.9949 12.9513 9.76243C12.7258 9.29697 12.2635 8.96046 11.7545 8.87932C11.3206 8.81599 10.8895 8.72468 10.4757 8.57716C10.3252 8.52654 10.1754 8.46906 10.0177 8.44413C9.69657 8.38894 9.35942 8.43472 9.06441 8.57334C8.72066 8.72315 8.48608 9.0271 8.21849 9.27687C7.21897 8.64761 6.36874 7.78689 5.73226 6.79163C5.94425 6.56983 6.18747 6.3717 6.34817 6.10641C6.60764 5.69818 6.6579 5.17015 6.49771 4.71512C6.35858 4.31757 6.23545 3.91239 6.17224 3.495C6.13796 3.26431 6.10293 3.02827 5.99934 2.81666C5.75308 2.26904 5.18135 1.89286 4.58271 1.87658C4.01529 1.87378 3.44762 1.87658 2.8802 1.87505C2.43134 1.87124 1.98503 2.06632 1.6819 2.398C1.43487 2.66125 1.28382 3.01022 1.25564 3.36987C1.23863 3.53214 1.26351 3.69467 1.28534 3.85516C1.56613 6.17483 2.60931 8.38309 4.17548 10.1088C5.29306 11.3394 6.69548 12.298 8.22205 12.9456C9.05934 13.2872 9.9342 13.5377 10.8289 13.672C11.0987 13.7028 11.3681 13.7717 11.6415 13.7432C12.1495 13.7018 12.6278 13.4022 12.8886 12.9634ZM12.0353 12.2144C11.9977 12.4634 11.7644 12.6651 11.5131 12.6663C9.14921 12.4377 6.89147 11.3333 5.22527 9.64288C3.68829 8.06668 2.65501 5.99348 2.36914 3.80506C2.34833 3.63769 2.29653 3.45889 2.36991 3.29687C2.44835 3.09237 2.66339 2.95197 2.88147 2.9596C3.43162 2.95858 3.98152 2.96036 4.53168 2.95858C4.74443 2.96469 4.95565 3.09924 5.02928 3.30323C5.08031 3.44795 5.08894 3.6031 5.11712 3.75292C5.17449 4.08535 5.25878 4.41244 5.36084 4.73369C5.40425 4.86544 5.45401 4.99541 5.49057 5.1292C5.54135 5.31462 5.47509 5.52191 5.33672 5.6529C5.11356 5.87826 4.88761 6.10081 4.66547 6.32718C4.5068 6.4859 4.46465 6.74457 4.56265 6.94602C5.15368 7.98783 5.94375 8.91773 6.88512 9.65789C7.07198 9.8138 7.2766 9.94607 7.47234 10.0903C7.64067 10.2035 7.81762 10.3032 7.98899 10.4118C8.14131 10.513 8.34441 10.5351 8.51223 10.4614C8.62038 10.4169 8.70137 10.3296 8.78185 10.2482C8.97682 10.0537 9.168 9.85552 9.36399 9.66196C9.47036 9.56251 9.61482 9.49867 9.76182 9.50782C9.87961 9.50833 9.98777 9.56022 10.0982 9.59379C10.5402 9.74844 10.9967 9.86391 11.4605 9.92928C11.5803 9.95014 11.707 9.96921 11.8071 10.044C11.9594 10.1473 12.0462 10.3322 12.0399 10.5148C12.0366 11.0812 12.0457 11.6482 12.0353 12.2144Z" fill="#686868" />
		<path d="M11.8565 6.39419C11.8802 6.29836 11.8811 6.1981 11.8595 6.10197C11.7096 5.36522 11.3388 4.67372 10.7997 4.14873C10.2678 3.62168 9.57318 3.2641 8.8369 3.12982C8.67161 3.10971 8.49626 3.15259 8.36586 3.25788C8.20471 3.38329 8.11127 3.59062 8.12664 3.7944C8.13965 4.02126 8.28573 4.23598 8.49449 4.32649C8.63553 4.38801 8.79166 4.39866 8.93537 4.45219C9.76035 4.71365 10.423 5.43354 10.6049 6.28121C10.6368 6.44447 10.7004 6.6101 10.8314 6.71953C11.0037 6.87097 11.2622 6.91888 11.4754 6.83163C11.6643 6.76005 11.811 6.59058 11.8565 6.39419Z" fill="#686868" />
	</svg>
);
